module.exports = __webpack_public_path__ + "img/pontos-destaque.13c12615.png";